/* LUNAMAR · ficha de producto · Itera · 28-sep-2026 · sin dependencias.
   Lee todo de #lnmData, que escribe sections/lnm-principal.liquid a partir del producto.
   Nada de este archivo es propio de un producto: sirve para cualquiera que suba Lunamar. */
(function () {
  'use strict';
  var dataEl = document.getElementById('lnmData');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  document.documentElement.classList.add('lnm-js');

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var cop = function (c) { return '$' + String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };
  /* escribe solo si el bloque existe: cualquiera se puede ocultar desde el editor */
  var put = function (sel, prop, val) { var e = typeof sel === 'string' ? $(sel) : sel; if (e) e[prop] = val; return e; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var REGALO = D.regalo || 0, GIFT = D.gift, ENVIO = D.envio;
  /* qué falta para el siguiente escalón: regalo sorpresa, gift box, envío gratis */
  var ESC = [[REGALO, 'el regalo sorpresa'], [GIFT, 'la gift box'], [ENVIO, 'el envío gratis']].filter(function (e) { return e[0] > 0; });
  function siguiente(t) { for (var i = 0; i < ESC.length; i++) if (t < ESC[i][0]) return ESC[i]; return null; }
  function ganados(t) { return ESC.filter(function (e) { return t >= e[0]; }).map(function (e) { return e[1].replace(/^(el|la) /, ''); }); }
  function frase(t) {
    var s = siguiente(t), g = ganados(t);
    var ya = g.length ? (g.length === ESC.length ? '' : g.join(' y ').replace(/^./, function (c) { return c.toUpperCase(); }) + ' incluido' + (g.length > 1 ? 's' : '') + '. ') : '';
    return s ? ya + 'Te faltan <b>' + cop(s[0] - t) + '</b> para ' + s[1] : '<b>Regalo, gift box y envío gratis incluidos</b>';
  }

  var porId = {};
  D.variants.forEach(function (v) { porId[v.id] = v; });
  var ini = $('#lnmVarId');
  var st = { v: porId[ini && ini.value] || D.variants[0], q: 1, look: false };
  var LOOK = [];      /* piezas sugeridas: {id, title, url, variants, variant_id, price, img, thumb, misma} */
  var mini = null;    /* la pieza del «compra el look» de la columna */
  var carrito = { item_count: 0, total_price: 0, items: [] };

  /* ---------- galería: la foto de cada variante abre su tramo ---------- */
  var abre = {};
  D.variants.forEach(function (v) { if (v.media) abre[v.media] = true; });
  var porColor = D.variants.length > 1 && !!D.portada;
  function fotosDe(v) {
    if (!porColor || !v.media) return D.media;
    var seg = [], por = [], tramo = 'portada';
    D.media.forEach(function (m) {
      if (abre[m.id]) tramo = m.id;
      if (tramo === 'portada') por.push(m);
      else if (tramo === v.media) seg.push(m);
    });
    return v.media === D.portada ? por.concat(seg) : seg.concat(por);
  }
  var track = $('#lnmGalTrack'), cuenta = $('#lnmGalCount'), galActual = '';
  function pintaGaleria(fade) {
    if (!track) return;
    var set = fotosDe(st.v), clave = set.map(function (m) { return m.id; }).join(',');
    if (clave === galActual) return;
    var primera = galActual === '';
    galActual = clave;
    if (primera && track.children.length) { cuentaFotos(); pintaPines(); return; } /* ya viene pintada desde Liquid */
    track.innerHTML = set.map(function (m, k) {
      var cota = porColor && m.id === st.v.media && D.medida ? '<span class="lnm-cota">' + esc(D.medida) + '</span>' : '';
      return '<figure class="lnm-gal__item' + (fade ? ' lnm-fade' : '') + '" data-media="' + m.id + '"><img src="' + m.src + '" alt="' + esc(m.alt) + '"' +
        (k > 1 ? ' loading="lazy"' : '') + '>' + cota + '</figure>';
    }).join('');
    track.scrollLeft = 0;
    cuentaFotos();
    pintaPines();
    if (fade) requestAnimationFrame(function () { requestAnimationFrame(function () {
      $$('.lnm-fade', track).forEach(function (f) { f.classList.remove('lnm-fade'); });
    }); });
  }
  /* ---------- pines sobre la foto: «Lo que lleva puesto» + «Puntos del look» del producto ---------- */
  var PINS = [];
  (function () {
    var xy = String(D.puntos || '').split(';');
    (D.puesto || []).forEach(function (p, k) {
      var c = (xy[k] || '').split(',');
      var x = parseFloat(c[0]), y = parseFloat(c[1]);
      if (p.id === D.id) return; /* el pin señala lo que se suma al look, nunca la pieza de esta ficha */
      if (!isNaN(x) && !isNaN(y)) PINS.push({ p: p, x: Math.max(4, Math.min(96, x)), y: Math.max(4, Math.min(96, y)) });
    });
  })();
  function fotoDelLook() {
    if (!PINS.length) return null;
    if (D.fotoLook > 0 && D.media[D.fotoLook - 1]) return D.media[D.fotoLook - 1].id;
    return null;
  }
  function pintaPines() {
    if (!PINS.length || !track) return;
    $$('.lnm-pin, .lnm-pin__tip', track).forEach(function (e) { e.remove(); });
    var id = fotoDelLook(), fig = id ? $('[data-media="' + id + '"]', track) : track.children[0];
    if (!fig) return;
    PINS.forEach(function (pin, k) {
      var p = pin.p, propio = p.id === D.id;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lnm-pin'; b.style.left = pin.x + '%'; b.style.top = pin.y + '%';
      b.setAttribute('aria-label', 'Ver ' + p.title); b.innerHTML = '<i></i>';
      var t = document.createElement('div');
      t.className = 'lnm-pin__tip' + (pin.x > 55 ? ' lnm-pin__tip--izq' : '') + (pin.y > 70 ? ' lnm-pin__tip--arriba' : '');
      t.style.left = pin.x + '%'; t.style.top = pin.y + '%';
      var accion = propio ? '<span class="lnm-pin__nota">Esta pieza</span>'
        : (p.variants === 1 && p.available ? '<button type="button" class="lnm-pin__add" data-v="' + p.variant_id + '">Agregar</button>'
        : '<a class="lnm-pin__add" href="' + p.url + '">Ver</a>');
      t.innerHTML = '<img src="' + p.thumb + '" alt="" width="44" height="55"><div><b>' + esc(p.title) + '</b><span class="lnm-num">' + cop(p.price) + '</span>' + accion + '</div>';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var abierto = t.classList.contains('is-on');
        $$('.lnm-pin__tip.is-on', track).forEach(function (x) { x.classList.remove('is-on'); });
        if (!abierto) t.classList.add('is-on');
      });
      var ad = t.querySelector('button.lnm-pin__add');
      if (ad) ad.addEventListener('click', function (e) { e.stopPropagation(); agregar([{ id: +ad.dataset.v, quantity: 1 }], ad); });
      fig.appendChild(b); fig.appendChild(t);
    });
  }
  document.addEventListener('click', function (e) { if (!e.target.closest('.lnm-pin, .lnm-pin__tip')) $$('.lnm-pin__tip.is-on').forEach(function (x) { x.classList.remove('is-on'); }); });

  function cuentaFotos() {
    if (!cuenta || !track) return;
    var n = track.children.length, i = Math.round(track.scrollLeft / (track.clientWidth || 1)) + 1;
    cuenta.textContent = n > 1 ? Math.min(i, n) + ' / ' + n : '';
  }
  on(track, 'scroll', cuentaFotos, { passive: true });

  function textoBoton(v) {
    var b = $('#lnmAdd'), d = b ? b.dataset : {};
    if (!v.available) return d.agotado || 'Agotado';
    return st.look && mini ? (d.txt2 || 'Agregar los 2') : (d.txt || 'Agregar al carrito');
  }
  /* ---------- disponibilidad en vivo: inventario real de la variante ---------- */
  function pintaStock(v) {
    var el = $('#lnmStock'); if (!el) return;
    var d = el.dataset, n = v.qty, u = +d.umbral || 5, txt, clase = 'ok';
    if (!v.available) { txt = d.agotado; clase = 'off'; }
    else if (typeof n === 'number' && n > 0 && n <= u) { txt = (d.pocas || 'Últimas [n] unidades').replace('[n]', n); clase = 'pocas'; }
    else txt = d.ok;
    el.className = 'lnm-stock lnm-stock--' + clase;
    put('#lnmStockTxt', 'textContent', txt);
  }
  /* ---------- variante ---------- */
  function pintaVariante(url) {
    var v = st.v;
    $$('#lnmVarOpts .lnm-var__opt').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.id === v.id)); });
    var nom = $('#lnmVarName'); if (nom) nom.textContent = v.title;
    var sv = $('#lnmStickyVar'); if (sv && D.variants.length > 1) sv.textContent = v.title;
    if (ini) ini.value = v.id;
    var sku = $('#lnmSku'); if (sku) sku.textContent = v.sku;
    put('#lnmPrice', 'textContent', cop(v.price));
    var was = $('#lnmWas'), badge = $('#lnmSaleBadge'), oferta = v.compare > v.price;
    if (was) { was.hidden = !oferta; was.textContent = oferta ? cop(v.compare) : ''; }
    if (badge) { badge.hidden = !oferta; badge.textContent = oferta ? '-' + Math.floor((v.compare - v.price) * 100 / v.compare) + '%' : ''; }
    put('#lnmStickyPrice', 'textContent', cop(v.price));
    $$('[data-lnm-precio]').forEach(function (e) { e.textContent = cop(v.price); });
    ['#lnmAdd', '#lnmStickyAdd', '#lnmAddFin'].forEach(function (s) { var b = $(s); if (b) b.disabled = !v.available; });
    put('#lnmAddTxt', 'textContent', textoBoton(v));
    var sig = $('#lnmVarSig'); if (sig) { sig.hidden = !v.sig; sig.innerHTML = esc(v.sig || '').replace(/\n/g, '<br>'); }
    pintaStock(v);
    pintaCompra();
    pintaEscalera();
    if (url && history.replaceState && D.variants.length > 1) {
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    }
  }
  /* la elegida queda visible en la fila deslizable del celular */
  var opSel = $('#lnmVarOpts [aria-pressed="true"]'); if (opSel && opSel.scrollIntoView) opSel.parentNode.scrollLeft = Math.max(0, opSel.offsetLeft - 24);
  $$('#lnmVarOpts .lnm-var__opt').forEach(function (b) {
    on(b, 'click', function () {
      var v = porId[b.dataset.id];
      if (!v || v === st.v) return;
      st.v = v;
      pintaVariante(true);
      pintaGaleria(true);
    });
  });

  /* ---------- cantidad y «compra el look» de la columna ---------- */
  function seleccion() { return st.v.price * st.q + (st.look && mini ? mini.price : 0); }
  function pintaCompra() {
    put('#lnmQty', 'textContent', st.q);
    var qi = $('#lnmQtyIn'); if (qi) qi.value = st.q;
    var sel = seleccion();
    put('#lnmAddPrice', 'textContent', cop(sel));
    if (!mini) return;
    var msg;
    if (!st.look) {
      var con = sel + mini.price, sg = siguiente(con), antes = siguiente(sel);
      msg = 'Súmala y vas en <b>' + cop(con) + '</b>: ' + (sg ? (antes !== sg ? 'llega ' + antes[1] + ' y ' : '') + 'te faltan <b>' + cop(sg[0] - con) + '</b> para ' + sg[1] + '.' : 'regalo, gift box y envío gratis incluidos.');
    } else {
      msg = 'Vas en <b>' + cop(sel) + '</b>. ' + frase(sel) + '.';
    }
    put('#lnmNudge', 'innerHTML', msg);
  }
  on($('#lnmQtyPlus'), 'click', function () { st.q = Math.min(10, st.q + 1); pintaCompra(); pintaEscalera(); });
  on($('#lnmQtyMinus'), 'click', function () { st.q = Math.max(1, st.q - 1); pintaCompra(); pintaEscalera(); });
  on($('#lnmLookChk'), 'change', function () {
    st.look = this.checked;
    put('#lnmAddTxt', 'textContent', textoBoton(st.v));
    pintaCompra();
  });

  /* ---------- carrito: el lateral de Prestige, con su propio protocolo ----------
     1) cart:prepare-bundled-sections junta las secciones que el tema quiere repintar,
     2) /cart/add.js las pide de vuelta, 3) cart:change con baseEvent variant:add repinta y abre. */
  function pedir(url, cuerpo) {
    var op = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (cuerpo) { op.method = 'POST'; op.body = JSON.stringify(cuerpo); }
    return fetch(url, op).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function refrescar() {
    return pedir('/cart.js').then(function (c) { carrito = c; pintaCarrito(); pintaEscalera(); return c; });
  }
  function agregar(items, boton) {
    if (boton) boton.classList.add('lnm-cargando');
    avisa('');
    var secciones = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: secciones } }));
    return pedir('/cart/add.js', { items: items, sections: secciones.join(',') })
      .then(function (r) {
        return pedir('/cart.js').then(function (c) {
          c.sections = r.sections || {};
          carrito = c; pintaCarrito();
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true,
            detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: c } }));
          /* una app de Lunamar suma el obsequio unos segundos después: el lateral se repinta solo */
          setTimeout(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); refrescar().catch(function () {}); }, 1800);
        });
      })
      .catch(function (e) { avisa((e && (e.description || e.message)) || 'No pudimos agregarlo. Intenta de nuevo.'); })
      .then(function () { if (boton) boton.classList.remove('lnm-cargando'); });
  }
  var err = null;
  function avisa(t) {
    var f = $('#lnmForm'); if (!f) return;
    if (!err) { err = document.createElement('p'); err.className = 'lnm-pend'; err.setAttribute('role', 'alert'); f.parentNode.insertBefore(err, f.nextSibling); }
    err.textContent = t; err.hidden = !t;
  }
  /* sin carrito propio: solo la barra fija muestra cuánto falta para el envío */
  function pintaCarrito() {
    var pr = $('#lnmStickyProg');
    if (pr) pr.style.width = Math.min(100, carrito.total_price / ENVIO * 100) + '%';
  }
  document.addEventListener('cart:change', function (e) { if (e.detail && e.detail.cart && e.detail.cart.items) { carrito = e.detail.cart; pintaCarrito(); pintaEscalera(); } });

  function comprar(boton) {
    if (!st.v.available) return;
    var items = [{ id: st.v.id, quantity: st.q }];
    if (st.look && mini) items.push({ id: mini.variant_id, quantity: 1 });
    agregar(items, boton);
  }
  on($('#lnmForm'), 'submit', function (e) { e.preventDefault(); comprar($('#lnmAdd')); });
  on($('#lnmStickyAdd'), 'click', function () { comprar(this); });
  on($('#lnmAddFin'), 'click', function () { comprar(this); });

  /* ---------- barra fija: solo cuando el botón principal no se ve ---------- */
  /* Por scroll y no con IntersectionObserver: un salto de abajo a arriba no cruza el botón y dejaba la barra prendida */
  if ($('#lnmAdd')) {
    var stTick = false;
    var stMira = function () {
      stTick = false;
      var r = $('#lnmAdd').getBoundingClientRect();
      var fuera = r.bottom < 0 || r.top > window.innerHeight;
      put('#lnmSticky', 'className', 'lnm-sticky' + (fuera && (r.bottom < 0 || window.innerWidth < 1024) ? ' lnm-on' : ''));
    };
    var stPide = function () { if (!stTick) { stTick = true; requestAnimationFrame(stMira); } };
    window.addEventListener('scroll', stPide, { passive: true });
    window.addEventListener('resize', stPide);
    stMira();
  }

  /* ---------- compra el look: misma colección primero, recomendaciones de Shopify después ---------- */
  var lookSel = {};
  function pintaEscalera() {
    if (!$('#lnmLadderFill')) return;
    var ids = Object.keys(lookSel), t = carrito.total_price || 0;
    if (!carrito.items || !carrito.items.some(function (l) { return l.product_id === D.id; })) t += st.v.price * st.q;
    var pct = Math.min(100, t / ENVIO * 100);
    (($('#lnmLadderFill')||{style:{}}).style).width = pct + '%';
    (($('#lnmLadderYou')||{style:{}}).style).left = pct + '%';
    $('#lnmLadderYou').classList.toggle('lnm-fin-der', pct > 88);
    put('#lnmLadderAmt', 'textContent', cop(t));
    (($('#lnmMarkGift')||{style:{}}).style).left = (GIFT / ENVIO * 100) + '%';
    put('#lnmMarkGiftAmt', 'textContent', cop(GIFT));
    put('#lnmMarkEnvioAmt', 'textContent', cop(ENVIO));
    put('#lnmLadderMsg', 'innerHTML', frase(t));
    if ($('#lnmMarkRegalo')) { (($('#lnmMarkRegalo')||{style:{}}).style).left = (REGALO / ENVIO * 100) + '%'; put('#lnmMarkRegaloAmt', 'textContent', cop(REGALO)); $('#lnmMarkRegalo').hidden = !REGALO; }
    put('#lnmLookSum', 'textContent', cop(t));
    put('#lnmLookSumTxt', 'textContent', D.title + (ids.length ? ' + ' + ids.length + (ids.length > 1 ? ' piezas' : ' pieza') : ''));
    put('#lnmLookAdd', 'textContent', ids.length ? 'Agregar las ' + (ids.length + 1) + ' piezas' : 'Agregar al carrito');
  }
  function pintaLook() {
    var sec = $('#look'), grid = $('#lnmLookGrid');
    var cuatro = LOOK.slice(0, 4);
    if (sec && grid && cuatro.length >= 2) {
      var bolsa = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.5 8h13l-1 12h-11z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>';
      grid.innerHTML = cuatro.map(function (p) {
        var fotos = (p.imgs && p.imgs.length ? p.imgs : [p.img]).slice(0, 4);
        var boton = p.variants === 1
          ? '<button type="button" class="lnm-card__add lnm-card__add--bolsa" data-v="' + p.variant_id + '" aria-label="Agregar ' + esc(p.title) + ' al carrito">' + bolsa + '</button>'
          : '<a class="lnm-card__add lnm-card__add--bolsa" href="' + p.url + '" aria-label="Elegir ' + esc(p.title) + '">' + bolsa + '</a>';
        return '<article class="lnm-card" data-id="' + p.id + '"><figure><a class="lnm-card__track" href="' + p.url + '" tabindex="-1">' +
          fotos.map(function (f, k) { return '<img src="' + f + '" alt="' + (k ? '' : esc(p.title)) + '" loading="lazy">'; }).join('') + '</a>' +
          (fotos.length > 1 ? '<span class="lnm-card__dots">' + fotos.map(function (f, k) { return '<i' + (k ? '' : ' class="is-on"') + '></i>'; }).join('') + '</span>' : '') +
          (p.puesto ? '<span class="lnm-badge lnm-badge--accent">En la foto</span>' : '') + boton + '</figure>' +
          '<h3><a href="' + p.url + '">' + esc(p.title) + '</a></h3><p class="lnm-num">' + cop(p.price) + '</p></article>';
      }).join('');
      $$('.lnm-card', grid).forEach(function (c) {
        var tr = $('.lnm-card__track', c), dots = $$('.lnm-card__dots i', c);
        if (tr && dots.length) tr.addEventListener('scroll', function () { var k = Math.round(tr.scrollLeft / (tr.clientWidth || 1)); dots.forEach(function (d, x) { d.classList.toggle('is-on', x === k); }); }, { passive: true });
        var b = $('button.lnm-card__add', c); if (!b) return;
        b.addEventListener('click', function () { agregar([{ id: +b.dataset.v, quantity: 1 }], b); });
      });
      sec.hidden = false;
      $$('.lnm-reveal', sec).forEach(function (el) { observa(el); });
      pintaEscalera();
    }
    mini = LOOK.filter(function (p) { return p.variants === 1; })[0] || null;
    var box = $('#lnmLookMini');
    if (box && mini) {
      $('#lnmLookImg').src = mini.thumb;
      put('#lnmLookName', 'textContent', mini.title);
      put('#lnmLookNota', 'textContent', mini.puesto ? 'En la foto' : mini.misma ? D.lookNota : '');
      put('#lnmLookPrice', 'textContent', '+' + cop(mini.price));
      box.hidden = false;
      pintaCompra();
    }
    pintaCarrito();
  }
  on($('#lnmLookAdd'), 'click', function () {
    var items = [{ id: st.v.id, quantity: st.q }];
    Object.keys(lookSel).forEach(function (id) { items.push({ id: lookSel[id].variant_id, quantity: 1 }); });
    agregar(items, this);
  });
  function ancho(u, w) { return u ? (u.indexOf('//') === 0 ? 'https:' + u : u) + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function desdeColeccion() {
    if (!D.tag) return Promise.resolve([]);
    /* sin cabecera Accept: con «application/json» Shopify ignora ?view= y devuelve el JSON genérico de la colección */
    return fetch('/collections/all/' + encodeURIComponent(D.tag) + '?view=lnm-look')
      .then(function (r) { return r.ok ? r.text() : '{"products":[]}'; })
      .then(function (t) { try { return JSON.parse(t).products; } catch (e) { return []; } })
      .then(function (ps) { return ps.map(function (p) { p.misma = true; return p; }); })
      .catch(function () { return []; });
  }
  function desdeShopify() {
    return fetch('/recommendations/products.json?product_id=' + D.id + '&limit=8&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        return (j.products || []).map(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          return { id: p.id, title: p.title, url: p.url, available: p.available, variants: p.variants.length, variant_id: v.id,
            price: v.price, compare: v.compare_at_price || 0, img: ancho(p.featured_image, 700), thumb: ancho(p.featured_image, 160), misma: false,
            imgs: (p.images || []).slice(0, 4).map(function (u) { return ancho(u, 700); }) };
        });
      })
      .catch(function () { return []; });
  }
  desdeColeccion().then(function (a) {
    var vistos = {}; vistos[D.id] = true;
    a = (D.puesto || []).concat(a);
    var lista = a.filter(function (p) { if (vistos[p.id] || !p.available) return false; vistos[p.id] = true; return true; });
    var listos = function () {
      /* un clic primero; dentro de cada grupo, la misma colección antes que lo recomendado */
      LOOK = lista.sort(function (x, y) { return (y.puesto === true) - (x.puesto === true) || (y.variants === 1) - (x.variants === 1) || (y.misma === true) - (x.misma === true); });
      pintaLook();
    };
    if (lista.filter(function (p) { return p.variants === 1; }).length >= 4) return listos();
    return desdeShopify().then(function (b) {
      b.forEach(function (p) { if (!vistos[p.id] && p.available) { vistos[p.id] = true; lista.push(p); } });
      listos();
    });
  });

  /* ---------- dos variantes: elige y vuelve arriba ---------- */
  $$('[data-elegir]').forEach(function (b) {
    on(b, 'click', function () {
      var o = $('#lnmVarOpts [data-id="' + b.dataset.elegir + '"]');
      if (o) o.click();
      $('.lnm-pdp').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- preguntas: la pestaña solo filtra; sin JS se ve todo ---------- */
  var tabs = $$('.lnm-faq__tabs [role=tab]');
  function filtraFaq(tab) {
    tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.tab === tab ? 'true' : 'false'); });
    $$('.lnm-faq__list details').forEach(function (d) { d.classList.toggle('lnm-off', d.dataset.tab !== tab); });
  }
  tabs.forEach(function (t) { on(t, 'click', function () { filtraFaq(t.dataset.tab); }); });
  if (tabs.length) filtraFaq(tabs[0].dataset.tab);

  /* ---------- entradas al hacer scroll ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('lnm-vis'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function observa(el) { if (io) io.observe(el); else el.classList.add('lnm-vis'); }
  $$('.lnm-reveal').forEach(observa);

  /* ---------- la cabecera del tema decide dónde se pega la columna de compra ---------- */
  var cab = $('.shopify-section--header, height-observer[variable="header"], header');
  if (cab) document.documentElement.style.setProperty('--lnm-head', Math.min(140, cab.getBoundingClientRect().height + 16) + 'px');

  pintaGaleria(false);
  pintaVariante();
  refrescar().catch(function () {});
})();
